import React from "react";
import Layoute from "../components/layoute";
import { Card, Col, Row, Button, Modal, Pagination } from "antd";
import {
  Form,
  Input,
  Tooltip,
  Icon,
  Cascader,
  Select,
  Checkbox,
  AutoComplete,
  notification,
} from "antd";
import { Upload, message, Tag } from "antd";
import moment from "moment";

const { TextArea } = Input;
const { Meta } = Card;
const FormItem = Form.Item;
const Option = Select.Option;
const AutoCompleteOption = AutoComplete.Option;

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJPG = file.type === "image/jpeg";
  if (!isJPG) {
    message.error("You can only upload JPG file!");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("Image must smaller than 2MB!");
  }
  return isJPG && isLt2M;
}

class News extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      confirmDirty: false,
      autoCompleteResult: [],
      selectedNews: {},
      loading: false,
      loading2: false,

      subscribe: true,
      ModalText: "Content of the modal",
      visible: false,
      visible2: false,
      visibleModification: false,
      visibleView: false,
      confirmLoading: false,
      selectedNews: [
        {
          title: "",
        },
      ],
      modules: {
        toolbar: [
          [{ size: ["normal", "large", "huge"] }],
          ["bold", "italic", "underline"],
          [{ align: [] }],
          [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
          ],
          ["link", "image"],
        ],
      },
      news: [],
      loadingNews: true,
    };
    if (typeof window !== "undefined") {
      this.quill = require("react-quill");
    }
  }

  handleChange = (info) => {
    if (info.file.status === "uploading") {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (imageUrl) =>
        this.setState({
          imageUrl,
          loading: false,
        })
      );
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        console.log("Received values of form: ", values);
      }
    });
  };
  showModalView = (n) => {
    this.state.selectedNews = n;
    console.log(this.state.selectedNews);
    this.setState({
      visibleView: true,
    });
  };

  handleOkView = (n) => {
    this.setState({
      visibleView: false,
      selectedNews: {},
    });
  };

  showModal = (type) => {
    this.setState({
      visible: true,
      type: type == "lehubbezannes" ? "lehubbezannes" : null,
    });
  };

  handleOk = (e) => {
    this.setState({
      confirmLoading: true,
    });

    const formData = new FormData();

    formData.append("title", this.state.selectedNews.title);
    formData.append("description", this.state.selectedNews.description);
    formData.append("leHubBezannesAuthor", this.state.type == "lehubbezannes");

    if (this.state.selectedNews.pdf) {
      formData.append("pdf", this.state.selectedNews.pdf);
    }

    fetch("/api/news", {
      credentials: "include",
      method: "POST",
      headers: {
        "x-access-token": localStorage.getItem("x-access-token"),
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        data.author = JSON.parse(localStorage.getItem("user"));
        this.setState({
          news: [...this.state.news, data],
          selectedNews: {},
          visible: false,
          confirmLoading: false,
          type: null,
        });
        notification["success"]({
          message: "Demande envoyée",
          description: "La demande a été envoyée et est en cours de validation",
        });
      });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  handleCancelView = () => {
    console.log("Clicked cancel button");
    this.setState({
      visibleView: false,
    });
  };

  showModalModification = (n) => {
    this.setState({
      visibleModification: true,
      selectedNews: n,
    });
  };

  handleCancelModification = () => {
    this.setState({
      visibleModification: false,
    });
  };

  handleOkModification = () => {
    this.props.form.validateFields((err, values) => {
      this.setState({
        selectedNews: {
          ...this.state.selectedNews,
          ...values,
        },
        confirmLoading: true,
      });

      fetch("/api/news", {
        credentials: "include",
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": localStorage.getItem("x-access-token"),
        },
        body: JSON.stringify({
          id: this.state.selectedNews._id,
          news: values,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          var oldNews = this.state.news.filter((d) => {
            return d._id !== this.state.selectedNews._id;
          });

          this.setState({
            news: [...oldNews, data],

            visibleModification: false,
            confirmLoading: false,
          });

          notification["success"]({
            message: "Demande modifiée",
            description:
              "La demande a été modifiée et est en cours de validation",
          });
        });
    });
  };

  showModalRefus = (n) => {
    this.setState({
      visible2: true,
      selectedNews: n,
    });
  };

  handleOkRefus = (n) => {
    this.setState({
      confirmLoading: true,
    });

    console.log(this.state.selectedNews);
    const status = this.state.selectedNews.status;

    this.props.form.validateFields((err, values) => {
      //   this.state.selectedNews.status = 'refused';
      // this.state.selectedNews.explanation = values.explanation;

      fetch("/api/news/refuse", {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": localStorage.getItem("x-access-token"),
        },
        body: JSON.stringify({
          id: this.state.selectedNews._id,
          status: "refused",
          explanation: values.explanation,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.state.selectedNews.validator = JSON.parse(
            localStorage.getItem("user")
          );
          this.state.selectedNews.status = "refused";
          this.state.selectedNews.explanation = values.explanation;
          this.setState({
            // status : 'refused',
            visible2: false,
            confirmLoading: false,
          });
          notification["error"]({
            message: "Actualité refusée",
            description: "L'actualité a été refusée",
          });
        });
    });
  };

  handleCancelRefus = () => {
    this.setState({
      visible2: false,
    });
  };

  componentDidMount() {
    this.setState({
      loading2: true,
    });
    fetch("/api/news", {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          news: data.news,
          loading2: false,
          loadingNews: false,
        });
      });
  }

  validateNews(n) {
    this.setState({
      loading: true,
      activeLoading: n,
    });

    fetch("/api/news/custom", {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
      body: JSON.stringify({
        id: n._id,
        status: "validate",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        const validator = JSON.parse(localStorage.getItem("user"));
        this.setState({
          loading: false,
          activeLoading: null,
          news: this.state.news.map((item) =>
            item._id === n._id
              ? {
                  ...item,
                  status: "validate",
                  validator,
                }
              : item
          ),
        });
        notification["success"]({
          message: "Actualité validée",
          description: "L'actualité a été validée",
        });
      });
  }

  deleteNews(n) {
    this.setState({
      loading: true,
    });
    fetch("/api/news", {
      credentials: "include",
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
      body: JSON.stringify({
        id: n._id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          news: this.state.news.filter((a) => {
            return a._id !== n._id;
          }),
          loading: false,
        });
      });
  }

  render() {
    const {
      visible,
      visible2,
      visibleModification,
      visibleView,
      confirmLoading,
      ModalText,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    const ReactQuill = this.quill;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return (
      <div className="padding" style={{ padding: "30px" }}>
        <div
          className="buttonsContainer"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div>
            {(this.props.user.group &&
              this.props.user.group.findIndex(
                (f) => f.slug == "membre-du-bureau"
              ) !== -1) ||
            this.props.user.admin ? (
              <Button
                type="primary"
                size="large"
                onClick={() => this.showModal("lehubbezannes")}
                style={{ marginRight: 10 }}
              >
                <Icon type="plus-circle-o" />
                Actualité Le Hub Bezannes
              </Button>
            ) : null}
            {this.props.user.company.status == "actif" ? (
              <Button type="primary" size="large" onClick={this.showModal}>
                <Icon type="plus-circle-o" />
                Proposer une actualité
              </Button>
            ) : (
              <Button type="primary" size="large" disabled>
                <Icon type="plus-circle-o" />
                Proposer une actualité
              </Button>
            )}
            <Modal
              title="Creation de l'actualité"
              visible={visible}
              onOk={this.handleOk}
              confirmLoading={confirmLoading}
              onCancel={this.handleCancel}
              cancelText="Annuler"
              width={900}
            >
              <Form>
                <div className="news-item">
                  <p style={{ margin: "5px 0" }}>Titre :</p>
                  <Input
                    value={this.state.selectedNews.title}
                    onChange={(e) => {
                      this.setState({
                        selectedNews: {
                          ...this.state.selectedNews,
                          title: e.target.value,
                        },
                      });
                    }}
                    placeholder={"Précisez le titre"}
                  />
                </div>
                <div className="news-item">
                  <p style={{ margin: "5px 0" }}>
                    Pièce jointe (.PDF uniquement) :
                  </p>
                  <input
                    onChange={(e) => {
                      const pdf = e.target.files[0];
                      this.setState({
                        selectedNews: {
                          ...this.state.selectedNews,
                          pdf,
                        },
                      });
                    }}
                    type="file"
                    accept="application/pdf"
                  />
                </div>
                <div className="news-item">
                  <p style={{ margin: "5px 0" }}>Description :</p>
                  {ReactQuill ? (
                    <ReactQuill
                      value={this.state.selectedNews.description || ""}
                      modules={this.state.modules}
                      onChange={(e) => {
                        this.setState({
                          selectedNews: {
                            ...this.state.selectedNews,
                            description: e,
                          },
                        });
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </Form>
            </Modal>

            <Modal
              title="Refus de l'actualité"
              visible={visible2}
              onOk={this.handleOkRefus}
              confirmLoading={confirmLoading}
              onCancel={this.handleCancelRefus}
            >
              <Form>
                <FormItem {...formItemLayout} label="Explication du refus">
                  {getFieldDecorator("explanation", {
                    rules: [
                      {
                        required: false,
                        message: "Expliquez votre refus",
                      },
                    ],
                  })(
                    <div>
                      <TextArea
                        placeholder=""
                        autosize={{
                          minRows: 15,
                          maxRows: 50,
                        }}
                      />
                    </div>
                  )}
                </FormItem>
              </Form>
            </Modal>

            <Modal
              title="Apercu de l'actualité"
              visible={visibleView}
              onOk={this.handleOkView}
              confirmLoading={confirmLoading}
              onCancel={this.handleOkView}
              width={900}
              cancelText="Annuler"
            >
              <div>
                <p
                  style={{
                    marginBottom: "30px",
                    fontWeight: 500,
                    fontSize: "16px",
                  }}
                  className="title"
                >
                  {this.state.selectedNews.title}
                </p>
                {this.state.selectedNews.pdf ? (
                  <a
                    target="_blank"
                    href={this.state.selectedNews.pdf}
                    style={{
                      display: "inline-block",
                      margin: "10px 0",
                      textDecoration: "underline",
                    }}
                  >
                    Aperçu de la pièce jointe
                  </a>
                ) : null}
                <p
                  style={{ border: "1px dashed #d8d8d8", padding: "20px" }}
                  dangerouslySetInnerHTML={{
                    __html: this.state.selectedNews.description,
                  }}
                  className="description"
                ></p>
              </div>
            </Modal>
          </div>
        </div>
        {this.props.user.company.status == "actif" ? (
          this.state.news.length > 0 ? (
            <div>
              <Row gutter={16}>
                {this.state.news != null
                  ? this.state.news
                      .slice((this.state.page - 1) * 9, this.state.page * 9)
                      .map((n) => {
                        return (
                          <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 12 }}
                            xl={{ span: 8 }}
                            style={{ height: 220, marginBottom: 20 }}
                            key={n._id}
                          >
                            <Card
                              className="news-card"
                              style={{
                                marginBottom: "30px",
                                height: "100%",
                                paddingTop: 20,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                justifyContent: "center",
                              }}
                            >
                              <div className="status">
                                {n.status == "refused" ? (
                                  <Tag color="red">
                                    Refusé par {n.validator ? n.validator.firstname : "-"}{" "}
                                    {n.validator ? n.validator.lastname : ""}
                                  </Tag>
                                ) : null}
                                {n.status == "validate" ? (
                                  <Tag color="green">
                                    Validé par {n.validator ? n.validator.firstname : "-"}{" "}
                                    {n.validator ? n.validator.lastname : ""}
                                  </Tag>
                                ) : null}
                                {n.status == "waiting" ? (
                                  <Tag color="orange">
                                    En attente de validation
                                  </Tag>
                                ) : null}
                              </div>

                              <p
                                style={{
                                  color: "rgba(0, 0, 0, 0.85)",
                                  fontWeight: "500",
                                  fontSize: "16px",
                                }}
                              >
                                {n.title}
                              </p>
                              <p>
                                <Icon type="user" /> &nbsp;{n.author ? n.author.firstname : "-"}{" "}
                                {n.author ? n.author.lastname : ""}
                              </p>
                              {n.createdAt &&
                                moment().diff(moment(n.createdAt), "minutes") >
                                  5 && (
                                  <p>
                                    <Icon type="inbox" /> Demande le{" "}
                                    {moment(n.createdAt).format("DD/MM/YYYY")}
                                  </p>
                                )}
                              {n.status == "refused" ? (
                                <div>
                                  <div className="explanation">
                                    {n.explanation}
                                  </div>
                                  <div className="authorExplanation">
                                    <Icon type="user" /> &nbsp;{" "}
                                    {n.validator ? n.validator.firstname : "-"}{" "}
                                    {n.validator ? n.validator.lastname : ""}
                                  </div>
                                </div>
                              ) : null}

                              <div className="buttonsContainer">
                                <div className="left">
                                  {/* <Button
                                    type="danger"
                                    onClick={() => this.deleteNews(n)}
                                    style={{
                                      marginRight: "10px",
                                    }}
                                  >
                                    Supprimer
                                  </Button> */}

                                  <Button
                                    type="primary"
                                    onClick={() =>
                                      this.setState({
                                        visibleView: true,
                                        selectedNews: n,
                                      })
                                    }
                                    style={{
                                      marginRight: "10px",
                                    }}
                                  >
                                    Apercu
                                  </Button>
                                </div>
                                <div className="right">
                                  {n.status == "waiting" &&
                                  (this.props.user.admin ||
                                    this.props.user.group.filter((f) => {
                                      return f.slug == "membre-du-bureau";
                                    }).length > 0) ? (
                                    <Button
                                      type="primary"
                                      disabled={
                                        this.state.loading &&
                                        this.state.activeLoading &&
                                        n._id == this.state.activeLoading._id
                                      }
                                      loading={
                                        this.state.loading &&
                                        this.state.activeLoading &&
                                        n._id == this.state.activeLoading._id
                                      }
                                      onClick={() => this.validateNews(n)}
                                    >
                                      Valider
                                    </Button>
                                  ) : null}
                                  {n.status == "waiting" &&
                                  (this.props.user.admin ||
                                    this.props.user.group.filter((f) => {
                                      return f.slug == "membre-du-bureau";
                                    }).length > 0) ? (
                                    <Button
                                      type="danger"
                                      disabled={this.state.loading}
                                      loading={this.state.loading}
                                      onClick={() => {
                                        this.showModalRefus(n);
                                      }}
                                      style={{
                                        marginLeft: "10px",
                                      }}
                                    >
                                      Refuser
                                    </Button>
                                  ) : null}
                                </div>
                              </div>
                            </Card>
                          </Col>
                        );
                      })
                  : null}
              </Row>
              <Pagination
                current={this.state.page}
                onChange={(page) => this.setState({ page })}
                pageSize={9}
                total={this.state.news.length}
              />
            </div>
          ) : this.state.loadingNews ? (
            ""
          ) : (
            <div className="unauthorized">
              <div className="error-logo"></div>
              <div className="text">
                <h1>Vous n'avez pas encore proposé d'actualités</h1>
                <p>
                  Pour créer et partager vos actualités, cliquez sur le bouton
                  "Proposer une actualité" situé en haut à droite de la page.{" "}
                  <br />
                  Une fois effectué, votre demande sera examinée par les membres
                  du bureau avant d'être mise en ligne sur le site officiel du
                  Hub Bezannes.
                </p>
              </div>
            </div>
          )
        ) : (
          <div className="unauthorized">
            <div className="error-logo"></div>
            <div className="text">
              <h1>Vous n'êtes pas adhérent actif sur l'année en cours</h1>
              <p>
                Pour créer et partager vos actualités aux entreprises du Parc
                d'Affaires Reims Bezannes, vous devez être adhérent actif sur
                l'année en cours.
                <br />
                Pour renouveler ou adhérer à l'association,{" "}
                <a onClick={this.props.adModal}>cliquez ici</a>
              </p>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Form.create()(News);



// WEBPACK FOOTER //
// ./components/news.js